import script from "./DocumentsSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentsSkeleton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
